<div class="verticalFlex ">
  @if (isLoading || loa == null) {
    <div class="flex-1 d-flex justify-content-center align-items-center">
      <app-loading-spinner class=""></app-loading-spinner>
    </div>
  } @else {
    <div [style.--brand-color]="(brandDetails ? brandDetails.primaryColor : '')">
      @if (!loaService.isSubmittedLoa(loa)) {
        <app-loa-form [loa]="loa" [brandDetails]="brandDetails" [token]="token"
                      (submittedLoa)="loa = $event"
                      (pdfGenerated)="pdfFile = $event"></app-loa-form>
      } @else {
        <app-loa-submitted [brandDetails]="brandDetails" [pdfFile]="pdfFile" [isRenewal]="isRenewal"></app-loa-submitted>
      }
    </div>
  }
</div>
